import { HttpClient } from '@angular/common/http';
import { Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Label, LabelType } from '@jms/model';
import { Observable, catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ActivityTagsService {

    constructor(
        private http: HttpClient
    ) { }

    public getTags(type: LabelType): Signal<Label[]> {
        return toSignal(this.getTags$(type), { initialValue: [] });
    }

    public getTags$(type: LabelType): Observable<Label[]> {
        return this.http
            .get<Label[]>(`/api/label/tag/${type}`)
            .pipe(
                catchError(() => of([]))
            );
    }
}